import { ca } from '@cian/analytics';

import type { IPage } from './common';

const category = {
  subscription: 'Subscription',
  unsubscription: 'Unsubscription',
};

export interface ITrackSubscriptionToggleParams {
  label: string;
  isActive: boolean;
  page?: IPage;
}

/**
 * Отслеживает тогглы вкл/выкл подписок. Для тематик lifehack, illustratedarticle
 * будет отправляться label didgest из-за агрегации на бэке.
 * @param {string} label
 * @param {boolean} isActive
 * @param {IPage} page
 */
export function trackSubscriptionToggle({ label, isActive, page }: ITrackSubscriptionToggleParams) {
  ca('event', {
    action: 'Send',
    category: getCategory(!isActive),
    label,
    name: 'oldevent',
    page,
  });
}

function getCategory(isActive: boolean): string {
  return isActive ? category.subscription : category.unsubscription;
}
